import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { TerminalEntity } from "src/app/features/Terminal/types/TerminalEntity";
import { Checkbox, SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import {
    siteSelectConfig,
    statusSelectorConfig,
    terminalProfileSelectConfig,
    terminalTypeSelectConfig,
} from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const TerminalSearchForm: FC<SearchFormProps<TerminalEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item name="terminalType" label={t("terminalSearchForm.criteriaBadges.terminalType")}>
                <SelectDynamic
                    name="terminalType"
                    label={t("terminalSearchForm.criteriaBadges.terminalType")}
                    fieldConfig={terminalTypeSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.terminalId")} name="terminalId">
                <TextInput name="terminalId" />
            </Form.Item>
            <Form.Item name="organizationUnitId" label={t("terminalSearchForm.criteriaBadges.siteId")}>
                <SelectDynamic
                    name="organizationUnitId"
                    label={t("terminalSearchForm.criteriaBadges.siteId")}
                    fieldConfig={siteSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item name="status" label={t("terminalSearchForm.criteriaBadges.status")}>
                <SelectDynamic name="status" label={t("terminalSearchForm.criteriaBadges.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.weatTerminalId")} name="weatTerminalId">
                <TextInput name="weatTerminalId" />
            </Form.Item>
            <Form.Item name="terminalProfile" label={t("terminalSearchForm.criteriaBadges.terminalProfile")}>
                <SelectDynamic
                    name="terminalProfile"
                    label={t("terminalSearchForm.criteriaBadges.terminalProfile")}
                    fieldConfig={terminalProfileSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.serialNumber")} name="serialNumber">
                <TextInput name="serialNumber" />
            </Form.Item>
            <Form.Item label={t("terminalSearchForm.criteriaBadges.archived")} name="archived" valuePropName="checked">
                <Checkbox name="archived" label="" readOnly={false} />
            </Form.Item>
        </SearchForm>
    );
};
